// UserRateCardForm Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import UserRateItem from '../user_rateitem/user_rateitem.jsx'
import Button from '../../../common/common/button/button.jsx'

class UserRateCardForm extends Component {
  constructor (props) {
    super(props)

    this._rateItemReferences = {}
  }

  static get propTypes () {
    return {
      items: PropTypes.array,
      onChange: PropTypes.func,
      prefixCurrency: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      items: [],
      onChange: null,
      prefixCurrency: ''
    }
  }

  render () {
    return (
      <div className='user-ratecard-form'>
        <div className='form-layout'>
          <div className='layoutcol'>
            <div className='formsection'>
              <div className='formheader'>
                <h3>
                  <IntlMessage ident='setting.userForm.rateCardTitle' />
                </h3>
                <Button
                  className='button_save'
                  title='setting.userForm.titleNewRateCard'
                  type='button'
                  icon='common-add'
                  canHover={false}
                  onClick={this._onAddRateCard.bind(this)}
                />
              </div>
              <div className='formrow'>
                {this.props.items.length > 0 && (
                  <div className='itemheader'>
                    <div className='colleft'>
                      <span className='col'>
                        <IntlMessage ident='setting.userForm.datePlaceholder' />
                      </span>
                    </div>
                    <div className='colright'>
                      <span className='col'>
                        <IntlMessage ident='setting.userForm.ratePlaceholder' />
                      </span>
                      <span className='col'>
                        <IntlMessage ident='setting.userForm.costRatePlaceholder' />
                      </span>
                    </div>
                  </div>
                )}
                {this.props.items.map((item, idx) => {
                  return (
                    <UserRateItem
                      item={item}
                      key={`${item.date}-${idx}`}
                      ref={(ref) =>
                        (this._rateItemReferences[`rate-${idx}`] = ref)}
                      showDelete={this.props.items.length > 1}
                      onChange={this._onChangeItem.bind(this, idx)}
                      onDelete={this._onDelete.bind(this, idx)}
                      prefixCurrency={this.props.prefixCurrency}
                    />
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  validate () {
    for (const key in this._rateItemReferences) {
      if (this._rateItemReferences[key]) {
        this._rateItemReferences[key].validate()
      }
    }
  }

  /* Event handler */
  _onAddRateCard (ev) {
    ev.preventDefault()
    this.props.items.push({ date: new Date(), rate: 0, costRate: 0 })
    this.setState({ dataDate: new Date() })
  }

  _onChangeItem (itemIdx, item) {
    this.props.items[itemIdx] = item

    if (this.props.onChange) {
      this.props.onChange(this.props.items)
    }

    this.setState({ dataDate: new Date() })
  }

  _onDelete (itemIdx) {
    _.remove(this.props.items, (obj, idx) => idx === itemIdx)

    if (this.props.onChange) {
      this.props.onChange(this.props.items)
    }

    this.setState({ dataDate: new Date() })
  }
}

export default UserRateCardForm
